import styled from 'styled-components';
import logoMark from '../../../assets/finect-logo-mark.svg';

export const MainLink = styled.span`
  position: absolute;
  top: 14px;
  left: 0;

  /* stylelint-disable */
  a {
    display: block;
    opacity: 0.5;
    width: 12px;
    height: 27px;
    background: url(${logoMark});
    background-size: auto 100%;

    &:hover {
      opacity: 1;
    }
  }
  /* stylelint-enable */
`;
